<template>
  <AVRankedSummary
    :result="result.resultDataForDisplay"
    :distribution-number="distributionNo"
    :seats="contest.seats"
    :hide-tied="!votingRoundReport.colorTied"
    :hide-elected="!votingRoundReport.colorElected"
    :theme="theme"
    :vote-counts="result.voterCounts"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Option from "../frontend/shared/Option.vue";
import type { ConferenceContest, PropType, Result, Theme, E2E } from "@/types";

export default defineComponent({
  name: "RankedSummary",
  components: { Option },
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
    votingRoundReport: {
      type: Object as PropType<E2E.VotingRoundReport>,
      required: true,
    },
    contest: {
      type: Object as PropType<ConferenceContest>,
      required: true,
    },
    theme: {
      type: String as PropType<Theme>,
      default: "dark",
    },
  },
  computed: {
    distributionNo() {
      return this.result.resultData.distributionNo;
    },
  },
});
</script>
